import { useUsersQuery } from './useUsersQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface CoreUsersDeleteMutationParams {
  userIds: string[];
}

export const useCoreUsersDeleteMutation = createMutationHook(
  'settings.teamPermissions.usersDelete',
  (params: CoreUsersDeleteMutationParams) => ({
    coreUsersDelete: {
      __args: {
        input: {
          userIds: params.userIds,
        },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
  {
    invalidateQueries: [useUsersQuery],
  },
);
